import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-advice";
const API_PATH_2 = ConstantList.API_EN_POINT + "/related-person";
const API_PATH_3 = ConstantList.API_EN_POINT + "/patient-note";

export const saveNotePatient = (obj) => axios.post(API_PATH_3 + "/save-or-update", obj);

export const pagingNotePatient = (searchObject) => axios.post(API_PATH_3 + "/search-by-page", searchObject);

export const getNotePatientById = (NoteId) => axios.get(API_PATH_3 + "/get-by-id/" + NoteId);

export const deleteNotePatient = NoteId => axios.delete(API_PATH_3 + '/mark-delete/' + NoteId);

export const pagingPatientAdvise = (searchObject) =>
  axios.post(API_PATH + "/paging", searchObject);

export const getPatientAdviseById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveItemAdvise = (obj) =>
  axios.post(API_PATH + "/add-patient-advice-item", obj);

export const updateItemAdvise = (obj) =>
  axios.post(API_PATH + "/edit-patient-advice-item", obj);

export const deleteItemAdvise = (obj) =>
  axios.post(API_PATH + "/update-delete-patient-advice-item", obj);

export const clearItemPatientAdvice = (obj) =>
  axios.post(API_PATH + "/clear-item-patient-advice", obj);

export const updateItemAdviseStatus = (obj) =>
  axios.post(API_PATH + "/update-patient-advice-status", obj);

export const getItemAdviseById = (id) =>
  axios.get(API_PATH + "/get-item-by-id/" + id);

export const saveRalationship = (obj) => axios.post(API_PATH_2 + "/save", obj);

export const removeRalationship = (id) =>
  axios.delete(API_PATH_2 + "/mark-delete/" + id);

export const getListPatientAdviceItem = (obj) =>
  axios.post(API_PATH + "/get-list-patient-advice-item", obj);
